<footer *ngIf="isVisible" class="footer w-100 bottom-0 start-0 text-light" style="position: relative; z-index:3;">
  <a id="releasenote" (click)="openReleaseNotesDialog()"
    data-bs-toggle="modal"
    data-bs-target="#release-notes"
    i18n="@@ReleaseNotesButton"
  >Release&nbsp;Notes</a>
  
  <a id="aboutus" (click)="openAboutUsDialog()"
    data-bs-toggle="modal"
    data-bs-target="#impressum"
    i18n="@@ImprintButton"
  >Impressum</a>

  <a id="datasecurity" (click)="openDSDialog()"
    data-bs-toggle="modal"
    data-bs-target="#datenschutz"
    i18n="@@PrivacyPolicyButton"
  >Datenschutz</a>

  <a id="agb" href="https://uploads-ssl.webflow.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf" target="_blank"
  >AGB</a>

  <a id="cookies" onclick="document.getElementById('cookie-consent-banner').classList.add('show')"
  >Cookies</a>

  <a id="cubos" href="https://www.cubos.com" target="_blank" class="me-2" i18n="@@CUBOSName">
    ©&nbsp;{{currentYearLong()}}&nbsp;CUBOS&nbsp;Service GmbH
  </a>
</footer>

